// we can't use import.meta with jest
// so we are creating a file where we declare all of our env variables
// and we mock this file in jest

import { resolveSentryEnabled } from './resolveSentryEnabled'

// CARE-OFFICE-BMA: `vite serve` (local dev/HMR) never sets VITE_SENTRY_ENABLED,
// so an unset value must default to off there, not on.
const isSentryEnabled = (): boolean =>
  resolveSentryEnabled(import.meta.env.VITE_SENTRY_ENABLED, import.meta.env.DEV)

const CONSTANTS = {
  ENV_MODE: import.meta.env.MODE,
  PROD: import.meta.env.PROD,
  VITE_APP_ROTA_API_WS: import.meta.env.VITE_APP_ROTA_API_WS,
  VITE_APP_ROTA_API_WS_PATH: import.meta.env.VITE_APP_ROTA_API_WS_PATH,
  VITE_SENTRY_ENABLED: isSentryEnabled(),

  VITE_APP_ROTA_API: import.meta.env.VITE_APP_ROTA_API,
  VITE_APP_ROTA_WS: import.meta.env.VITE_APP_ROTA_WS,
  VITE_API_CM_URL_PROXY: import.meta.env.VITE_API_CM_URL_PROXY,
  VITE_APP_CM_API: import.meta.env.VITE_APP_CM_API,
  VITE_APP_EMAR_API: import.meta.env.VITE_APP_EMAR_API,
  VITE_ROSTERING_MODULE_URL: import.meta.env.VITE_ROSTERING_MODULE_URL,
  VITE_FUSIONAUTH_APP_CO_CLIENT_ID: import.meta.env
    .VITE_FUSIONAUTH_APP_CO_CLIENT_ID,
  VITE_FUSIONAUTH_URL: import.meta.env.VITE_FUSIONAUTH_URL,
  VITE_INSIGHTS_APP_URL: import.meta.env.VITE_INSIGHTS_APP_URL,
  VITE_REACT_APP_GOOGLE_MAPS_API_KEY: import.meta.env
    .VITE_REACT_APP_GOOGLE_MAPS_API_KEY,
  VITE_RELEASE_NAME: import.meta.env.VITE_RELEASE_NAME,
  VITE_SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV
}

export default CONSTANTS
